var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thermodynamic_scale"},[(_vm.type)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_c('div',{staticClass:"scale"},[_c('div',{staticClass:"bar",style:(_vm.style)}),_c('div',{staticClass:"label"},_vm._l(([100, 50, 0]),function(v){return _c('div',{key:v,staticClass:"item"},[_vm._v(_vm._s(v)+"%")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }